<form #actualForm="ngForm" [formGroup]="form" class="dt-form" (ngSubmit)="onSubmit()">
  <dt-password-form [newPassword]="true" [passwordChange]="true"></dt-password-form>
  @if (form.hasError('server-error')) {
    <mat-error i18n>Bei der Datenübertragung ist ein Fehler aufgetreten, versuche es eventuell später erneut.</mat-error>
  }
  @if (form.hasError('wrong-password')) {
    <mat-error i18n>Dein altes Passwort ist falsch.</mat-error>
  }
  <button
    mat-raised-button
    type="submit"
    color="accent"
    [disabled]="(!form.valid && !actualForm.submitted) || form.disabled"
    [dtOverlayProgress]="form.disabled"
    i18n
    >Passwort ändern</button
  >
</form>
